import { getPageQuery } from "@/utils/utils";
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu, Spin } from "antd";
import React, { useCallback } from "react";
import { history, useModel } from "umi";
import HeaderDropdown from "../HeaderDropdown";
import styles from "./index.less";
// import UpdatePassword from '@/pages/index/updatePassword';

export interface GlobalHeaderRightProps {
  menu?: boolean;
  from?: String;
}

/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async () => {
  localStorage.removeItem("sessionid");
  localStorage.removeItem("menuType");
  const { redirect } = getPageQuery();
  if (window.location.pathname !== "/user/login" && !redirect) {
    history.replace({
      pathname: "/user/login",
      // search: stringify({
      // 	redirect: window.location.href,
      // }),
    });
  }
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, from }) => {
  const { initialState, setInitialState } = useModel("@@initialState");
  const onMenuClick = useCallback((event: any) => {
    const { key } = event;
    if (key === "logout") {
      setInitialState({ ...initialState, currentUser: undefined });
      localStorage.removeItem("sessionid");
      loginOut();
      return;
    }
    if (key === "accountsettings") {
      history.push("/accountsettings");
    }
  }, []);

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;
  if (!currentUser) {
    return loading;
  }
  const menuHeaderDropdown = (
    <Menu
      className={styles.menu}
      selectedKeys={[]}
      onClick={(e) => onMenuClick(e)}
    >
      {menu && (
        <Menu.Item key="center">
          <UserOutlined />
          个人中心
        </Menu.Item>
      )}
      {menu && (
        <Menu.Item key="settings">
          <SettingOutlined />
          个人设置
        </Menu.Item>
      )}
      {menu && <Menu.Divider />}

      <Menu.Item key="logout">
        <LogoutOutlined style={{ color: initialState.settings.colorPrimary }} />
        退出登录
      </Menu.Item>
      <Menu.Item key="accountsettings">
        <SettingOutlined
          style={{ color: initialState.settings.colorPrimary }}
        />
        个人设置
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      <HeaderDropdown overlay={menuHeaderDropdown}>
        <div className={`${styles.action} ${styles.account}`}>
          <a>
            <UserOutlined
              style={{
                color:
                  initialState.settings.layout == "mix"
                    ? "white"
                    : "rgba(0,0,0,0.88)",
              }}
            />
          </a>
          <span
            className={`${styles.name} anticon`}
            style={{
              color:
                initialState.settings.layout == "mix"
                  ? "white"
                  : "rgba(0,0,0,0.88)",
            }}
          >
            {currentUser?.data?.zsxm}
          </span>
        </div>
      </HeaderDropdown>
      {/* <UpdatePassword
			title='当前密码等级危险，请修改密码'
			closeable={false}
			modalVisible={initialState ?.currentUser ?.data ?.mmdj == -1}
			countDown={300}
		/> */}
    </>
  );
};

export default AvatarDropdown;
